import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const ActionRoot = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.75, 1.5),
  marginTop: theme.spacing(1),

  border: `1px dashed ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  fontSize: '0.75rem',
  textTransform: 'uppercase',
  letterSpacing: '0.12em',

  '&::before': {
    content: '"▶"',
    color: theme.palette.primary.main,
    fontSize: '0.7rem',
  },

  '&:hover': {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

export function ProfileActionButton({
  label = 'View Full Profile',
  href,
}: {
  label?: string;
  href: string;
}) {
  const handleClick = () => {
    window.open(href, '_blank', 'noopener noreferrer');
  };

  return (
    <ActionRoot onClick={handleClick}>
      <Typography
        variant="caption"
        sx={{ fontSize: '0.7rem', letterSpacing: '0.12em' }}
      >
        {label}
      </Typography>
    </ActionRoot>
  );
}
